/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useLayoutEffect, useRef, Suspense, lazy, useMemo, useCallback } from "react";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import {
  Switch,
  Route,
  Link,
  Redirect,
  useLocation
} from "react-router-dom";
import { getEvenId, setSocketData, setSocketNotification } from "../src/components/AppSlice";
import SubMenu from "./components/SubMenu";
import { setOpen } from "./components/AppSlice";
import Login from "./components/Login/login";
import { tabManager, setOpenTabs, setTabStack } from "./components/sidebar/sidebarSlice";
import {
  getBrand,
} from "./components/Dashboard/dashboardSlice";
import { getBrandCurrenciesList } from "./components/createbonusnew/createbonusnewslice";
import { getPendingNotifications } from "./components/PendingWithrawals/pendingWithrawalSlice";
import NavigationTabs from "./components/Common/NavigationTabs/NavigationTabs";
import Header from "./components/Common/Header/Header";
import ForceLogout from "./components/Login/ForceLogout";
import TotpAuth from "./components/Auth/TotoAuth";
import TotpLogin from "./components/Auth/TotpLogin";
import AddNewPassword from "./components/Login/AddNewPassword";
import Toaster from "../src/sharedfiles/Toaster"
// import { LOGIN_CONSTANTS } from "./sharedfiles/Constants";
import { setBiReportData, setVipBiReportData } from "./components/Reports/BiReports/bireportSlice";
import notty from './sounds/notification.mp3';
import { notySubscribe, notyUnSubscribe, toaster, urlB64ToUint8Array, formatReportFileName, getDateTimeFromKey, getReportNameFromKey, getPartNumberFromKey, downloadZipFile } from "./sharedfiles/helper";
import { startSessionTimer, stopSessionTimer } from "./sharedfiles/sessionTimer";
// import * as serviceWorker from "./serviceWorker";
import { setBiDashboardData } from "./components/BiDashboard/biDashSlice";
import { getListOfURLs } from "./sharedfiles/helper";
import starbetLogo from "./starbet-logo.svg"
import Forbidden from "./components/Routes/Forbidden";
import ProtectedRoute from "./components/Routes/ProtectedRoutes";
import NoPermissionRoutes from "./components/Routes/NoPermissionRoutes";
import NElogo from "./assets/images/logo-mobile.svg"
import { VIP_BI_REPORTS_DEV, VIP_BI_REPORTS_PROD } from "./components/VipReports/ProdVipReport";
// import BetVitaLogo from './assets/images/brandLogo/Betvita.png'
import BetVitaLogo from './assets/images/brandLogo/betvita.png'
import BetCoreectLogo from './assets/images/brandLogo/betCorrect.png'
import TopSahaLogo from './assets/images/brandLogo/topSaha.png'
import SokabetLogo from './assets/images/brandLogo/sokaBet.png'
import store from "./app/store";

// Restores each route's previous scroll position (or scrolls to top for a
// route visited for the first time) inside the main content area.
// useLocation is available here because index.js wraps the entire app in <Router>.
const SCROLL_POS_PREFIX = "mainScrollPos:";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Keep recording the scroll position of whichever route is currently active.
  useEffect(() => {
    const handleScroll = (e) => {
      if (e.target?.id === "main-scroll-container") {
        sessionStorage.setItem(SCROLL_POS_PREFIX + pathname, String(e.target.scrollTop));
      }
    };
    // Capture phase: fires regardless of whether main-scroll-container exists
    // yet when this listener is attached, and regardless of scroll events not
    // bubbling from the element that actually scrolled.
    document.addEventListener("scroll", handleScroll, { capture: true });
    return () => document.removeEventListener("scroll", handleScroll, { capture: true });
  }, [pathname]);

  // Restore the saved position whenever the route changes. useLayoutEffect
  // runs before paint so the jump to the saved offset isn't visible.
  useLayoutEffect(() => {
    const container = document.getElementById("main-scroll-container");
    if (!container) return;

    const saved = sessionStorage.getItem(SCROLL_POS_PREFIX + pathname);
    const target = saved ? parseInt(saved, 10) || 0 : 0;
    container.scrollTo({ top: target, behavior: "instant" });

    if (target > 0) {
      // main-scroll-container's own box is fixed by the surrounding flex/h-screen
      // layout, so it never resizes as content loads - watch its scrollable
      // content instead so growth (lazy-loaded pages/tables) is actually detected.
      const content = container.querySelector("main") || container;
      const observer = new ResizeObserver(() => {
        container.scrollTo({ top: target, behavior: "instant" });
      });
      observer.observe(content);
      const timeoutId = setTimeout(() => observer.disconnect(), 2000);
      return () => {
        observer.disconnect();
        clearTimeout(timeoutId);
      };
    }
  }, [pathname]);

  return null;
};

// Defined outside App so React never sees it as a new component type on re-renders
const CustomToast = ({ message, title }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
    {title && (
      <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: '#f5f5f7', lineHeight: 1.4 }}>
        {title}
      </p>
    )}
    {message && (
      <p style={{ margin: 0, fontSize: '12.5px', color: '#a1a1aa', lineHeight: 1.5 }}>
        {message}
      </p>
    )}
  </div>
);

// Lazy-loaded route components — split into separate chunks, loaded only when navigated to
const BiReport = lazy(() => import("./components/Reports/BiReports/biReport"));
const BiDashboard = lazy(() => import("./components/BiDashboard/BiDashboard"));
const AllReport = lazy(() => import("./components/Reports/BiReports/AllBiReport"));
const AllDashboardReport = lazy(() => import("./components/BiDashboard/AllDashboardRepo"));
const VipRepo = lazy(() => import("./components/VipReports/VipRepo"));
const App = (props) => {
  // const location = useLocation();
  const dispatch = useDispatch();
  const [brand, setBrand] = useState("");
  // const history = useHistory();
  const [nToggler, setNToggler] = useState(false);
  const nRef = useRef(null);
  // props.token (Redux) covers the window between setToken(true) and getBrand setting merchantId,
  // preventing the login page from flashing while the brand API loads after login.
  const token = props.token || (localStorage.getItem("token") && localStorage.getItem("merchantId"));
  // const brandId = parseInt(localStorage.getItem("brandId"))
  const handleSidebarClick = useCallback(() => {
    dispatch(setOpen(!props.open));
  }, [dispatch, props.open]);
  const userId = localStorage.getItem("logUserId")
  const brandHandler = (e) => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        registrations.forEach(function (registration) {
          registration.unregister()
            .then((unregister) => {
              dispatch(notyUnSubscribe())
            })
            .catch((error) => {
              console.log('Service Worker unregistration failed:', error);
            });
        });
      }).then(function () {
        navigator.serviceWorker.register('/sw.js', { scope: '/public/' });
      });
    }
    localStorage.setItem("merchantkey", e.target.value);
    setBrand(e.target.value ? e.target.value : "");

    const item = props.brandData.filter(
      (item) => item.merchantKey === e.target.value
    )[0];
    const userID = item.brandId;
    const currency = item.currency;
    const logUserId = props.platformUserDetails.platformUsers.id
    localStorage.setItem("brandId", userID);
    localStorage.setItem("currency", currency);
    localStorage.setItem("logUserId", logUserId);
    localStorage.setItem("userId", "");

    // Clear all open tabs so the new brand starts with a clean tab state
    dispatch(setTabStack([]));
    dispatch(setOpenTabs([]));
    localStorage.removeItem("tabStack");
    localStorage.removeItem("openTabs");

    window.location.href = "/dashboardV2";
  };

  const requestPermission = () => {
    const must = token && userId
    if ('Notification' in window && navigator.serviceWorker) {
      Notification.requestPermission(status => {
        if (status === "granted" && must) {
          dispatch(notySubscribe())
        }
        if (status !== "granted" && must) {
          dispatch(notyUnSubscribe())
        }
      });
    }
  }


  const downloadFile = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const callServiceWorker = async () => {
    const swKey = 'BBYCxwATP2vVgw7mMPHJfT6bZrJP2iUV7OP_oxHzEcNFenrX66D8G34CdEmVULNg4WJXfjkeyT0AT9LwavpN8M4=';
    const applicationServerKey = urlB64ToUint8Array(swKey);

    try {
      const permission = await Notification.requestPermission();
      const must = token && userId;
      if (permission === 'granted') {
        if (must) dispatch(notySubscribe());
      } else {
        if (must) dispatch(notyUnSubscribe());
        return;
      }

      const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/public/' });

      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey
      });

      const endpoint = subscription.endpoint;
      localStorage.setItem("endpoint", endpoint);
      const p256dhKey = subscription.getKey("p256dh");
      const uint8Array = new Uint8Array(p256dhKey);
      const base64String = btoa(String.fromCharCode.apply(null, uint8Array));
      localStorage.setItem("Publickey", base64String);

      const auth = subscription.getKey("auth");
      const uint8Array2 = new Uint8Array(auth);
      const base64String2 = btoa(String.fromCharCode.apply(null, uint8Array2));
      localStorage.setItem("auth", base64String2);
    } catch (error) {
      console.error('Service Worker registration or push subscription failed:', error);
    }
  };



  useEffect(() => {
    if ('serviceWorker' in navigator) {
      callServiceWorker()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const handleResize = () => {
      const shouldBeOpen = window.innerWidth >= 768;
      if (shouldBeOpen !== props.open) {
        dispatch(setOpen(shouldBeOpen));
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch, props.open]);

  const getOriginalReportKey = (key) => {
    return key.replace(/_\d{8}_\d+$/, "");
  };

  const handleLogOut = () => {
    stopSessionTimer();
    // Disconnect WebSocket before clearing storage to avoid stale subscriptions on next login
    import("./sharedfiles/Socket").then(({ disconnectSocket }) => {
      disconnectSocket();
    }).catch(() => { });
    localStorage.removeItem("merchantId");
    localStorage.removeItem("token");
    localStorage.removeItem("tab");
    localStorage.removeItem("userId");
    localStorage.setItem("userId", "");
    localStorage.removeItem("tab");
    localStorage.removeItem("isExist");
    localStorage.removeItem("isMasking");
    localStorage.clear();
    sessionStorage.clear();
    // props.history.push("/login")
  };


  const handleNotification = (event) => {
    if (nRef.current && !nRef.current.contains(event.target)) {
      setNToggler(false);
    }
  };

  useEffect(() => {
    let mounting = true;
    if (mounting) {
      if (token) {
        dispatch(getBrand(props));
        const merchantKey = localStorage.getItem("merchantkey") || localStorage.getItem("merchantId");
        if (merchantKey) {
          store.dispatch(getListOfURLs("ALL_DOWNLOAD_URLS"));
        }
      }
      document.addEventListener("mousedown", handleNotification);
    }
    return () => {
      mounting = false;
      document.removeEventListener("mousedown", handleNotification, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!token) {
      handleLogOut();
    } else {
      startSessionTimer();
      dispatch(getBrandCurrenciesList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  const routeCheck = useCallback((page) => {
    const data = props.userPagePermissions.length > 0 &&
      [...props.userPagePermissions].map((item) => item.permissionName);

    if (data && data.length > 0) {
      if (
        page === "becomeaffiliate" &&
        data.includes("ADMIN_BECOME_AFFILIATE") &&
        props.notifications?.pendingAffiliateUserRequestCount > 0
      ) {
        return "/becomeaffiliate";
      }
      if (
        page === "withdrawals" &&
        data.includes("PAYMENT_PENDING_WITHDRAWALS_OFFLINE")
      ) {
        return "/pendingwithdrawalsoffline";
      }
    }
    return "";
  }, [props.userPagePermissions, props.notifications]);

  const navigateToDestination = useCallback((page) => {
    const path = routeCheck(page);
    if (path) {
      dispatch(tabManager(path, props.tabStack));
    }
  }, [dispatch, routeCheck, props.tabStack]);


  useEffect(() => {
    if (
      props.notifications?.totalCount &&
      props.notifications?.totalCount !== undefined &&
      props.notifications?.totalCount > 0
    ) {
      document.title = `Astra (${props.notifications?.totalCount || 0})`;
    }
  }, [props.notifications]);

  useEffect(() => {
    const env = process.env.REACT_APP_REPORTS;
    if (env === "dev") {
      Promise.all([
        import("./components/Reports/BiReports/biDataDev"),
        import("./components/BiDashboard/devDashData"),
      ]).then(([{ BiReportsDev }, { dashboardReportDev }]) => {
        dispatch(setBiReportData(BiReportsDev));
        dispatch(setBiDashboardData(dashboardReportDev));
        dispatch(setVipBiReportData([VIP_BI_REPORTS_DEV[0]]));
      });
    } else if (env === "qa") {
      Promise.all([
        import("./components/Reports/BiReports/biDataQA"),
        import("./components/BiDashboard/qaDashData"),
      ]).then(([{ BiReportsQA }, { dashboardReportQA }]) => {
        dispatch(setBiReportData(BiReportsQA));
        dispatch(setBiDashboardData(dashboardReportQA));
      });
    } else if (env === "prod") {
      Promise.all([
        import("./components/Reports/BiReports/biDataProd"),
        import("./components/BiDashboard/prodDashData"),
      ]).then(([{ BiReportsProd }, { dashboardReportProd }]) => {
        dispatch(setBiReportData(BiReportsProd));
        dispatch(setBiDashboardData(dashboardReportProd));
        dispatch(setVipBiReportData([VIP_BI_REPORTS_PROD[0]]));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const notificationUpdate = useCallback((notification) => {
    dispatch(setSocketData(notification))
    dispatch(getPendingNotifications());
    try {
      new Audio(notty).play().catch(() => { });
    } catch (e) {
      console.log("Audio play error:", e);
    }
    dispatch(setSocketNotification(true))
    const msg = notification.message
    const title = notification.title
    toaster.success(<CustomToast message={msg} title={title} />)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    const notificationHandler = (e) => {
      notificationUpdate(e.detail);
    };
    window.addEventListener("notificationUpdates", notificationHandler, false);
    return () => {
      window.removeEventListener("notificationUpdates", notificationHandler, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const userID = userId ? userId : props?.loggedUserId;
    if (token && userID) {
      // Dynamically import socket.io-client only after auth — keeps it out of the initial bundle
      import("./sharedfiles/Socket").then(({ initSocket, subscribeNotification }) => {
        initSocket();
        subscribeNotification(userID);
      });
    }
    // props.loggedUserId added: token fires before getPlatformUserDetails() sets logUserId,
    // so this effect must also re-run when loggedUserId becomes available after login.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, props.loggedUserId])
  // useEffect(() => {
  //   const favicon = document.getElementById('favicon');
  //   if (starbetLogoPermission) {
  //     favicon.href = "/WAT_AFF.ico";
  //   } else {
  //     favicon.href = "/ne.svg";
  //   }
  // }, [starbetLogoPermission]);

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     // Check if the event is a page refresh
  //     if (event && event.persisted) { //event.persisted wil check if the event is caused by page reload or not
  //       return;
  //     }
  //     console.log('User is leaving. Logging out...');
  //     // localStorage.clear();
  //     history.push("/login");
  //   };
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === 'hidden' && localStorage.getItem('isNavigatingAway') !== 'true') {
  //       // The page is not visible (user is navigating away)
  //       localStorage.setItem('isNavigatingAway', 'true');
  //     } else if (document.visibilityState === 'visible' && localStorage.getItem('isNavigatingAway') === 'true') {
  //       // The page is visible again (user is coming back)
  //       localStorage.removeItem('isNavigatingAway');
  //       localStorage.clear();
  //     }
  //   };
  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   // Cleanup function
  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);


  const userPermissions = useMemo(
    () => props.userPagePermissions.map(item => item.permissionName),
    [props.userPagePermissions]
  );
  return (
    <React.Fragment>
      <Toaster isSocket={props?.socketNotification} />
      <>
        <ScrollToTop />
        <div className="min-h-screen bg-background">
          <>
            <Switch>
              <Route
                path="/"
                exact
                render={(props) =>
                  !token ? <Login {...props} cleanStore={handleLogOut} /> : <Redirect to={`/${props.defaultMainPath}`} />
                }
              />
              <Route
                exact
                path="/login"
                render={(props) =>
                  !token ? <Login {...props} cleanStore={handleLogOut} /> : <Redirect to={`/${props.defaultMainPath}`} />
                }
              />
              <Route
                path="/pinchange"
                render={(props) => <AddNewPassword {...props} />}
              />
              <Route
                path="/enabletotp"
                render={(props) =>
                  token ? (
                    <Redirect to={`/${props.defaultMainPath}`} />
                  ) : props.totpEnabled === "" ? (
                    <Redirect to="/login" />
                  ) : (
                    <TotpAuth {...props} />
                  )
                }
              />
              <Route
                path="/authenticate"
                render={(props) =>
                  token ? (
                    <Redirect to={`/${props.defaultMainPath}`} />
                  ) : props.totpEnabled === "" ? (
                    <Redirect to="/login" />
                  ) : (
                    <TotpLogin {...props} />
                  )
                }
              />
              <Route
                render={() =>
                  !token ? (
                    <Redirect to="/login" />
                  ) : (
                    <div className="flex h-screen overflow-hidden">
                      <SubMenu />

                      <div id="main-scroll-container" className="flex-1 flex flex-col min-h-screen overflow-auto">
                        {/* Header */}
                        <Header
                          open={props.open}
                          handleSidebarClick={handleSidebarClick}
                          notifications={props.notifications}
                          biReportURLs={props.biReportURLs}
                          formatReportFileName={formatReportFileName}
                          downloadFile={downloadFile}
                          getOriginalReportKey={getOriginalReportKey}
                          nToggler={nToggler}
                          setNToggler={setNToggler}
                          nRef={nRef}
                          navigateToDestination={navigateToDestination}
                          routeCheck={routeCheck}
                          brandData={props.brandData}
                          brand={brand}
                          brandHandler={brandHandler}
                          handleLogOut={handleLogOut}
                          isAffiliateUser={props.isAffiliateUser}
                          starbetLogoPermission={props.starbetLogoPermission}
                          betVitaLogo={props.betVitaLogo}
                          betCorrectLogo={props.betCorrectLogo}
                          sokaBetLogo={props.sokaBetLogo}
                          topSahaLogo={props.topSahaLogo}
                          NElogo={NElogo}
                          starbetLogo={starbetLogo}
                          BetVitaLogo={BetVitaLogo}
                          BetCoreectLogo={BetCoreectLogo}
                          SokabetLogo={SokabetLogo}
                          TopSahaLogo={TopSahaLogo}
                        />


                        {/* Main Content */}
                        <main className="flex-1 bg-background">
                          <Switch>
                            <React.Fragment>
                              <div className="p-4">
                                <NavigationTabs />
                                <Suspense fallback={
                                  <div className="flex items-center justify-center min-h-[400px]">
                                    <div className="text-center">
                                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
                                      <p className="text-muted-foreground">Loading...</p>
                                    </div>
                                  </div>
                                }>
                                  <ProtectedRoute
                                    userPermissions={userPermissions}
                                  />
                                  <NoPermissionRoutes />
                                  <Route
                                    path="/forbidden"
                                    render={(props) => <Forbidden {...props} />}
                                  />
                                  <Route
                                    path="/selflogout"
                                    render={(props) => <ForceLogout {...props} />}
                                  />
                                  <Route
                                    path="/bidashboard"
                                    exact
                                    render={(props) => <BiDashboard {...props} />}
                                  />
                                  <Route
                                    path="/bidashboard/:reportName"
                                    exact
                                    render={(props) => <AllDashboardReport {...props} />}
                                  />
                                  <Route
                                    path="/vip-reports/:reportName"
                                    exact
                                    render={(props) => <VipRepo {...props} />}
                                  />
                                  <Route
                                    path="/bireports"
                                    exact
                                    render={(props) => (
                                      <BiReport {...props} />
                                    )}
                                  />
                                  <Route
                                    path="/bireports/:categoryName/:reportName"
                                    exact
                                    render={(props) => <AllReport {...props} />}
                                  />
                                </Suspense>
                              </div>
                            </React.Fragment>
                          </Switch>
                        </main>
                      </div>
                    </div>
                  )}
              />
            </Switch>
          </>

          <footer id="footer"></footer>
        </div>
      </>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    open: state.appslice.open,
    token: state.loginSlice.token,
    brandData: state.dashboard.brandData,
    seasonDropdown: state.dashboard.seasonDropdown,
    userPermission: state.dashboard.userPermission,
    userPagePermissions: state.dashboard.userPagePermissions,
    notifications: state.pendingWithrawal.notifications,
    totpEnabled: state.loginSlice.totpEnabled,
    openTabs: state.sidebar.openTabs,
    tabStack: state.sidebar.tabStack,
    defaultMainPath: state.dashboard.defaultMainPath,
    platformUserDetails: state.loginSlice.platformUserDetails,
    socketNotification: state.appslice.socketNotification,
    loggedUserId: state.loginSlice.loggedUserId,
    isAffiliateUser: state.loginSlice.isAffiliateUser,
    starbetLogoPermission: state.dashboard.starbetLogoPermission,
    betVitaLogo: state.dashboard.betVitaLogo,
    betCorrectLogo: state.dashboard.betCorrectLogo,
    sokaBetLogo: state.dashboard.sokaBetLogo,
    topSahaLogo: state.dashboard.topSahaLogo,
    biReportURLs: state.bireportSlice.biReportURLs
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators(
      {
        getEvenId,
      },
      dispatch
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(App);